exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n\tfont-size: 16px;\n\tmargin-bottom: 0 !important;\n}\n\ntable tr {\n\ttransition: 0s;\n}\n\ntable td,\ntable th {\n\twhite-space: nowrap !important;\n\tpadding: 15px !important;\n}\n\ntd.collapsed,\nth.collapsed {\n\twidth: 1px;\n}\n\ntd.action {\n\topacity: 0;\n}\n\ntr:hover > td.action {\n\topacity: 1;\n}\n\ntd.action-container .action-item {\n\topacity: 0;\n}\n\ntr:hover > td.action-container .action-item {\n\topacity: 1;\n}\n\ntd.action i.material-icons {\n\tmargin: 3px 0 0 5px;\n}\n", ""]);

// exports
